import React from 'react'
import { Images } from '../../../utils/imageConstants'
import type { Message } from '../types'

interface UserMessageProps {
  message: Message
  getFileIcon: (fileType: 'pdf' | 'csv' | 'image' | 'xlsx' | 'xls' | 'other') => string | React.ReactNode
  getFileTypeLabel: (fileType: 'pdf' | 'csv' | 'image' | 'xlsx' | 'xls' | 'other') => string
}

const UserMessage: React.FC<UserMessageProps> = ({
  message,
  getFileIcon,
  getFileTypeLabel
}) => {
  return (
    <div className="statgpt-message-wrapper">
      <div className="statgpt-message-card">
        <div className="statgpt-message-avatar">
          <img src={Images.player_statgt_icon} alt="User" />
        </div>
        <div className="statgpt-message-content">
          {message.files && message.files.length > 0 && (
            <div className="statgpt-message-files">
              {message.files.map((fileWithKey, index) => (
                <div key={fileWithKey.key || index} className="statgpt-message-file-item">
                  <div className="statgpt-message-file-icon">
                    {getFileIcon(fileWithKey.fileType)}
                  </div>
                  <div className="statgpt-message-file-info">
                    <div className="statgpt-message-file-name">{fileWithKey.file.name}</div>
                    <div className="statgpt-message-file-type">{getFileTypeLabel(fileWithKey.fileType)}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {message.text && (
            <p className="statgpt-message-text">{message.text}</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default UserMessage

